<template>
  <div class="charge-container">
    <FilledBanner
      bg-image="https://video.reta-inc.com/image/default/CF2D04D6F30548B7A81F5FE3C030495B-6-2.jpg"
      :title="$t('选择最适合您的方案')"
      :subtitle="$t('客户经理可以根据您企业的独特需求提供正确的采购建议')"
      :btn-text="$t('联系我们')"
    />
    <div class="tab_container">
      <!-- <div class="limited-time-event">
        <div class="box" @click="handlerGoActivity">
          <img src="@/assets/images/gift-box.png" alt="gift-box" />
          <span>限时活动：推荐客户您将获得300元提成奖励，客户将享有50美元的海外雇佣优惠</span>
        </div>
      </div> -->
      <div class="tab-list">
        <div
          ref="itemContainer"
          class="item"
          v-for="(item, index) in chargeList"
          :key="item.title"
          :style="{ borderTopColor: item.borderColor }"
          :data-index="index + 1"
        >
          <div>
            <div class="title">{{ $t(item.title) }}</div>
            <div class="desc">{{ $t(item.desc) }}</div>
            <div
              class="price"
              :style="{
                'margin-top': locale === 'zh-CN' ? '0px' : '16px',
              }"
            >
              <div class="money">{{ item.money }}</div>
              <div class="time">{{ $t(item.time) }}</div>
            </div>
            <div class="list">
              <div class="desc-item" v-for="descItem in item.descList" :key="descItem">
                {{ $t(descItem) }}
              </div>
            </div>
          </div>
          <div class="btn" @click="onClick">{{ $t('服务咨询') }}</div>
        </div>
      </div>
      <div class="step_counter">
        <div
          v-for="item in 3"
          :class="{ current_counter: index === item }"
          :key="item"
          class="item"
          @click="scrollToItem(item)"
        ></div>
      </div>
    </div>
    <div class="extra_service">
      <article class="extra_title">{{ $t('额外服务') }}</article>
      <div class="services">
        <div class="item" v-for="{ title, content, img } in list" :key="title">
          <div class="left">
            <article class="title">{{ $t(title) }}</article>
            <article class="content">{{ $t(content) }}</article>
            <a-button type="outline" class="button" @click="connect(title)">
              {{ $t('联系我们') }}
              <img :src="arrowIcon" class="arrow" />
            </a-button>
          </div>
          <img :src="img" :alt="title" class="img" />
        </div>
      </div>
    </div>
    <!-- <div class="evaluation">
      <Evaluation />
      <nuxt-link to="/showcase/new-energy" class="showcase">
        {{ $t('查看客户案例') }}
        <icon-right />
      </nuxt-link>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import chargeList from '@/assets/contents/charge.json';
import arrowIcon from '@/assets/icons/arrow-down-blue.svg';
// import Evaluation from '@/pages/index/components/evaluation/index.vue';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();

useSeoHead();

const router = useRouter();
const moduleName = useState('module-name');
moduleName.value = 'charge';

function onClick() {
  useLeadsInfo('收费标准-费用明细-联系我们', 'serviceConsulting');
}
const index = ref(0);
const itemContainer = ref<HTMLDivElement[]>([]);
function initScrollListener() {
  const { length } = itemContainer.value;
  const io = new IntersectionObserver(
    entries => {
      for (let i = 0; i < entries.length; i++) {
        const item = entries[i];
        if (item.intersectionRatio >= 0.75) {
          index.value = Number(item.target.getAttribute('data-index')) || 0;
        }
      }
    },
    {
      threshold: 0.75,
    }
  );
  for (let i = 0; i < length; i++) {
    const item = itemContainer.value[i];
    io.observe(item as Element);
  }
}
function handlerGoActivity() {
  router.push({
    name: 'activity',
  });
}
function scrollToItem(count: number) {
  if (count === index.value) {
    return;
  }
  itemContainer.value[count - 1].scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
  });
}
onMounted(initScrollListener);

const list = [
  {
    title: '全球猎头',
    content: '帮助您在150+国家完成海外人才寻访',
    img: 'https://video.reta-inc.com/image/default/122E5BD1FE704F32A92147ECB8B540AF-6-2.png',
  },
  {
    title: '合规咨询',
    content: '为您提供专业的海外用工合规咨询',
    img: 'https://video.reta-inc.com/image/default/87F5C3BB28C247349C38F0118E819891-6-2.png',
  },
  {
    title: '企业落地',
    content: '帮助您完成海外实体注册',
    img: 'https://video.reta-inc.com/image/default/90BC638B90C647409A63945BD7E65AC0-6-2.png',
  },
  {
    title: '其他海外服务',
    content: '通过全球服务网络帮助您完成其他海外服务，例如办工签、办税等',
    img: 'https://video.reta-inc.com/image/default/3FD5E04859D24133BE3CE2C416A0EC1E-6-2.png',
  },
];
function connect(title: string) {
  useLeadsInfo(`收费标准-额外服务-${title}-联系我们`, 'contactUs');
}
</script>

<style lang="less" scoped>
@keyframes jitter {
  0% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  10% {
    transform: rotate(-12deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  20% {
    transform: rotate(12deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  28% {
    transform: rotate(-10deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  36% {
    transform: rotate(10deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  42% {
    transform: rotate(-8deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  48% {
    transform: rotate(8deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  52% {
    transform: rotate(-4deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  56% {
    transform: rotate(4deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  60% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
  }

  100% {
    transform: rotate(0deg);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
}

.limited-time-event {
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 48px;
  box-sizing: border-box;
  background-color: #ecf2ff;

  img {
    width: 35px;
    animation: jitter 1s 2s infinite;
  }

  .box {
    width: 680px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff3f1;
    border: 1px solid #ff8777;
    box-shadow: 0px 2px 8px rgba(114, 148, 226, 0.2);
    border-radius: 12px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #ff5c46;
    cursor: pointer;

    span {
      margin-left: 16px;
    }
  }
}

@media screen and (min-width: 800px) {
  :deep(.banner-container) {
    height: 360px;
    h2 {
      margin-top: 86px;
    }
    .try-button {
      margin-top: 48px;
    }
  }
  .charge-container {
    .tab-list {
      padding: 40px 0 120px 0px;
      background-color: #ecf2ff;
      display: flex;
      justify-content: center;
      gap: 25px;
      min-width: 1344px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 410px;
        background: #ffffff;
        border-radius: 4px;
        padding: 40px;
        box-sizing: border-box;
        position: relative;
        transition: all 0.3s;
        border-top-width: 4px;
        border-top-style: solid;

        .title {
          font-weight: 500;
          font-size: 30px;
          line-height: 42px;
          color: #11151f;
        }

        .desc {
          font-weight: 400;
          font-size: 18px;
          line-height: 25px;
          color: #86909c;
          margin-top: 12px;
          height: 77px;
          padding-top: 12px;
          box-sizing: border-box;
        }

        .price {
          .money {
            font-weight: 600;
            font-size: 42px;
            line-height: 55px;
            color: #386aff;
            display: inline-block;
            font-family: Silka, sans-serif, serif;
            letter-spacing: -1px;
          }

          .time {
            font-weight: 500;
            font-size: 24px;
            line-height: 34px;
            color: #86909c;
            display: inline-block;
            margin-left: 10px;
          }
        }

        .list {
          margin-top: 40px;

          .desc-item {
            margin-bottom: 20px;
            padding-left: 36px;
            background: url('@/assets/icons/tick.svg') no-repeat 0 0/24px 24px;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;
            color: #4e5969;
          }
        }

        .btn {
          width: 330px;
          height: 62px;
          border: 2px solid #165dff;
          border-radius: 8px;
          font-weight: 500;
          font-size: 24px;
          line-height: 34px;
          color: #165dff;
          text-align: center;
          line-height: 62px;
          cursor: pointer;

          &:hover {
            background: #165dff;
            color: #ffffff;
          }
        }

        &:hover {
          box-shadow: 0px 4px 24px rgba(114, 148, 226, 0.2);
        }
      }
    }

    .step_counter {
      display: none;
    }
    .extra_service {
      background-color: #fff;
      padding: 60px 0 66px;
      .extra_title {
        font-weight: 500;
        font-size: 32px;
        line-height: 48px;
        letter-spacing: 0.5px;
        color: #000000;
        text-align: center;
      }
      .services {
        width: 1280px;
        margin: 40px auto 0;
        display: flex;
        flex-wrap: wrap;
        gap: 36px;
        .item {
          box-sizing: border-box;
          width: 622px;
          background: #ffffff;
          box-shadow: 0px 2px 24px rgba(114, 148, 226, 0.14);
          border-radius: 12px;
          padding: 40px 32px 40px 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            max-width: 400px;
            .title {
              font-weight: 500;
              font-size: 28px;
              line-height: 39px;
              color: #1d2129;
            }
            .content {
              margin-top: 16px;
              margin-bottom: 36px;
              font-size: 18px;
              line-height: 25px;
              color: #4e5969;
            }
            .button {
              height: 42px;
              border: 1.5px solid #2656ff;
              filter: drop-shadow(0px 7px 8px rgba(89, 135, 255, 0.2));
              border-radius: 6px;
              font-weight: 500;
              font-size: 18px;
              line-height: 24px;
              text-align: center;
              color: #2656ff;
              display: flex;
              align-items: center;
              .arrow {
                // width: 24px;
                // height: 24px;
                margin-top: 2px;
                margin-left: 8px;
                transform: rotateZ(-90deg);
                // vertical-align: middle;
              }
            }
            .button:hover {
              border: 1.5px solid #4080ff;
              filter: drop-shadow(0px 7px 8px rgba(89, 135, 255, 0.2));
              border-radius: 6px;
              color: #4080ff;
              .arrow {
                opacity: 0.8;
              }
            }
          }
          .img {
            width: 117px;
            height: 122px;
          }
        }
      }
    }
  }
}
.evaluation {
  background: url('https://video.reta-inc.com/image/default/43291D4001D54758BD267F40B9A87CFB-6-2.png') no-repeat top center/878px 458px;
  :deep(.evaluation_container) {
    padding: 20px 0 50px;
    .evaluation_title::after {
      display: none;
    }
    .arco-image-img {
      vertical-align: middle;
      border-radius: inherit;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
  .showcase {
    color: #2656FF;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    text-align: center;
    margin-bottom: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
}

@font-face {
  font-family: Silka;
  src: url('https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/font/Silka-Medium.otf');
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 800px) {
  .charge-container {
    width: 100%;
    overflow-x: hidden;

    .limited-time-event {
      .box {
        padding: 10px 16px;
        font-size: 12px;
        line-height: 17px;
      }
    }

    .tab_container {
      background: #ecf2ff;
    }

    ::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .tab-list {
      background: #ecf2ff;
      padding: 40px 16px 24px;
      display: flex;
      gap: 24px;
      overflow-x: auto;

      .item {
        background: #ffffff;
        border-radius: 3px;
        padding: 24px 20px;
        border-top: 2px solid;
        box-sizing: border-box;
        min-width: 250px;
        width: 250px;
        height: 476px;
        position: relative;

        .title {
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 0.01em;
          color: #11151f;
        }

        .desc {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          letter-spacing: 0.01em;
          color: #86909c;
          margin-top: 8px;
          height: 34px;
        }

        .price {
          margin-top: 15px;

          .money {
            font-weight: 400;
            font-size: 34px;
            line-height: 34px;
            letter-spacing: 0.01em;
            color: #386aff;
            display: inline-block;
            font-family: Silka, sans-serif, serif;
          }

          .time {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.01em;
            color: #86909c;
            display: inline-block;
            margin-left: 4px;
          }
        }

        .list {
          margin-top: 16px;

          .desc-item {
            margin-bottom: 8px;
            padding-left: 16px;
            background: url('@/assets/icons/tick.svg') no-repeat 0 3px/12px 12px;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0.01em;
            color: #4e5969;
          }
        }

        .btn {
          display: block;
          width: 200px;
          height: 36px;
          position: absolute;
          bottom: 20px;
          border: 1px solid #165dff;
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          line-height: 34px;
          color: #165dff;
          text-align: center;
        }
      }
    }

    .step_counter {
      padding-bottom: 24px;
      display: flex;
      justify-content: center;
      gap: 8px;

      .item {
        width: 16px;
        height: 4px;
        background: #e5e7eb;
        border-radius: 2px;
      }

      .current_counter {
        background: #165dff;
      }
    }
    .extra_service {
      background-color: #fff;
      padding: 32px 16px 40px;
      .extra_title {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.5px;
        color: #000000;
        text-align: center;
      }
      .services {
        margin: 24px auto 0;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        .item {
          width: 100%;
          box-sizing: border-box;
          background: #ffffff;
          box-shadow: 0px 2px 24px rgba(114, 148, 226, 0.14);
          border-radius: 12px;
          padding: 20px 16px 20px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            max-width: 213px;
            .title {
              font-weight: 500;
              font-size: 18px;
              line-height: 25px;
              color: #1d2129;
            }
            .content {
              margin-top: 16px;
              margin-bottom: 36px;
              font-weight: 400;
              // font-size: 14px;
              line-height: 20px;
              color: #4e5969;
            }
            .button {
              height: 32px;
              border: 1.5px solid #2656ff;
              filter: drop-shadow(0px 7px 8px rgba(89, 135, 255, 0.2));
              border-radius: 6px;
              font-weight: 500;
              // font-size: 18px;
              line-height: 24px;
              text-align: center;
              color: #2656ff;
              display: flex;
              align-items: center;
              .arrow {
                // width: 24px;
                // height: 24px;
                margin-top: 2px;
                margin-left: 8px;
                transform: rotateZ(-90deg);
                // vertical-align: middle;
              }
            }
            .button:hover {
              border: 1.5px solid #4080ff;
              filter: drop-shadow(0px 7px 8px rgba(89, 135, 255, 0.2));
              border-radius: 6px;
              color: #4080ff;
              .arrow {
                opacity: 0.8;
              }
            }
          }
          .img {
            width: 82px;
            height: 86px;
          }
        }
      }
    }
  }
}
</style>
